var isClient = function () { return typeof window !== 'undefined'; };

export { isClient };
